function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-222.277 -66.868)"
}, React.createElement("g", {
  transform: "translate(222.277 177.781)"
}, React.createElement("path", {
  d: "M268.867,232.079c-13.168,4.589-22.046,5.992-46.431,21.616-.052.033-.106.066-.159.105.04-.053.076-.1.112-.155,17.229-23.28,19.226-32.043,24.689-44.873,5.489-12.887,20.746-19.394,20.746-19.394l11.749,10.808.047.05,9.993,12.449S282.094,227.469,268.867,232.079Z",
  transform: "translate(-222.277 -189.378)",
  fill: "#f89037"
}), React.createElement("path", {
  d: "M243.081,236.656a145.325,145.325,0,0,0,9-19.257c.778-1.932,1.582-3.93,2.459-5.988,2.882-6.766,13.149-14.683,17.3-17.135l7.386,7.9,7.593,8.122c-2.718,3.974-10.811,14.2-17.778,16.625-2.111.735-4.159,1.4-6.138,2.05A145.184,145.184,0,0,0,243.081,236.656Z",
  transform: "translate(-224.246 -189.842)",
  fill: "#f3be02"
}), React.createElement("path", {
  d: "M254.9,226.975c1.523-2.994,2.862-5.811,4.182-8.589l.016-.033c1.012-2.129,2.059-4.33,3.173-6.574,2.1-4.221,8.562-10.166,13.591-14.068l9.238,9.882c-4.436,5.307-10.471,11.355-14.544,13.049-2.317.963-4.588,1.861-6.785,2.73l-.026.01C260.89,224.512,257.991,225.657,254.9,226.975Z",
  transform: "translate(-225.366 -190.167)",
  fill: "#fbfaaa"
})), React.createElement("g", {
  transform: "translate(239.739 105.377)"
}, React.createElement("path", {
  d: "M285.893,148.168a24.516,24.516,0,0,0-9.215.674c-15.644,3.869-32.213,19.564-32.213,19.564l0-.007c-.2-.38-8.309-16.191,3.512-35.592,6.2-10.178,16.07-15.906,24.139-19.06a3.254,3.254,0,0,1,3.667.807,3.528,3.528,0,0,1,.958,2.5,3.289,3.289,0,0,1-1.094,2.315l23.121-5.7,17.313-4.265.007,0C306.968,128.37,285.893,148.168,285.893,148.168Z",
  transform: "translate(-241.565 -109.404)",
  fill: "#de3645"
}), React.createElement("path", {
  d: "M244.463,168.826c-.2-.38-8.309-16.191,3.512-35.591,6.2-10.178,16.07-15.906,24.139-19.06a3.254,3.254,0,0,1,3.667.807,3.528,3.528,0,0,1,.958,2.5q-.5,1.114-1.094,2.315s-17.1,7.908-25.449,23.792C241.981,159.222,244.387,168.539,244.463,168.826Z",
  transform: "translate(-241.565 -109.832)",
  fill: "#f24c65"
}), React.createElement("path", {
  d: "M289.565,148.168a24.516,24.516,0,0,0-9.214.674c4.556-13.663,13.779-26.038,22.088-35.169l17.313-4.265.007,0C310.64,128.37,289.565,148.168,289.565,148.168Z",
  transform: "translate(-245.236 -109.404)",
  fill: "#c0292c"
})), React.createElement("g", {
  transform: "translate(301.291 159.624)"
}, React.createElement("path", {
  d: "M332.531,196.842a24.51,24.51,0,0,1-1.292,9.148c-4.912,15.349-21.686,30.825-21.686,30.825l.007,0c.366.224,15.6,9.378,35.747-1.112,10.572-5.5,16.95-14.964,20.639-22.8a3.254,3.254,0,0,0-.558-3.715,3.534,3.534,0,0,0-2.43-1.123,3.291,3.291,0,0,0-2.383.936l7.237-22.687,5.42-16.986,0-.007C353.7,177.145,332.531,196.842,332.531,196.842Z",
  transform: "translate(-309.553 -169.323)",
  fill: "#de3645"
}), React.createElement("path", {
  d: "M309.561,240.87c.366.225,15.6,9.378,35.747-1.112,10.572-5.5,16.95-14.964,20.639-22.8a3.254,3.254,0,0,0-.558-3.714,3.534,3.534,0,0,0-2.43-1.124q-1.145.425-2.383.936s-9.04,16.532-25.449,23.791C318.975,243.99,309.842,240.965,309.561,240.87Z",
  transform: "translate(-309.554 -173.374)",
  fill: "#f24c65"
}), React.createElement("path", {
  d: "M334.8,196.842a24.508,24.508,0,0,1-1.292,9.148c13.939-3.627,26.906-12,36.575-19.674L375.5,169.33l0-.007C355.968,177.145,334.8,196.842,334.8,196.842Z",
  transform: "translate(-311.821 -169.323)",
  fill: "#c0292c"
})), React.createElement("path", {
  d: "M367.8,161.061a176.5,176.5,0,0,1-14.338,12.389,104.7,104.7,0,0,1-15.724,9.692c-.2.1-.4.2-.611.29l-10.443,4.5L315.142,192.9l-21.953,9.452-22.2-23.743,1.24-2.415,9.668-18.853,5.731-11.179a141.477,141.477,0,0,1,28.562-38.267c.333-.314.671-.634,1.009-.95,16.159-15.107,32.108-24.584,46.252-30.5q1.512-.633,2.994-1.211,3.559-1.389,6.941-2.489,1.457-.478,2.874-.9.724-.22,1.436-.425a119.009,119.009,0,0,1,16.471-3.542,98.154,98.154,0,0,1,13.655-1,5.865,5.865,0,0,1,6.049,6.469,109.657,109.657,0,0,1-6.559,29.752c-.185.512-.377,1.026-.572,1.544q-.52,1.38-1.091,2.793-1.332,3.288-2.954,6.743-.657,1.4-1.37,2.822C394.471,130.7,383.946,145.964,367.8,161.061Z",
  transform: "translate(-4.611 0)",
  fill: "#e8e8e8"
}), React.createElement("path", {
  d: "M365,164.565c30.86-29.839,39.261-55.32,39.391-55.716-36.33,55.788-80.021,79.526-102.431,88.631q1.251.944,2.547,1.845C321.2,192.517,349.464,179.585,365,164.565Z",
  transform: "translate(-7.543 -3.974)",
  fill: "#f4f6f7"
}), React.createElement("path", {
  d: "M304.667,207.924l-11.478,4.943q-1.854-1.141-3.6-2.365-1.476-1.036-2.873-2.137a57.886,57.886,0,0,1-8.893-8.616,52.3,52.3,0,0,1-6.835-10.625l5.7-11.12a82.13,82.13,0,0,0,8.891,13.2,79.328,79.328,0,0,0,13.441,12.825q1.251.944,2.547,1.845C302.583,206.575,303.617,207.259,304.667,207.924Z",
  transform: "translate(-4.611 -10.521)",
  fill: "#003557"
}), React.createElement("path", {
  d: "M277.826,189.333a52.306,52.306,0,0,1-6.835-10.625l5.7-11.12,5.2-10.148,5.731-11.179a141.477,141.477,0,0,1,28.562-38.267c.333-.314.671-.634,1.009-.95,21.867-20.443,43.348-30.578,60.5-35.529a119.016,119.016,0,0,1,16.471-3.542c.585,4.319,2.38,4.885-3.252,11.788,0,0-48.786,11.07-74.03,43.95-23.125,30.121-9.118,32.645-9.118,32.645l-22.183,24.427Z",
  transform: "translate(-4.611 -0.105)",
  opacity: 0.2
}), React.createElement("g", {
  transform: "translate(264.429 131.118)"
}, React.createElement("path", {
  d: "M271.473,209.375a1.916,1.916,0,0,1-2.441-2.611c14.137-29.288,55.833-57.675,73.266-68.618a1.911,1.911,0,0,1,2.564,2.743C332.772,157.546,301.645,197.24,271.473,209.375Z",
  transform: "translate(-268.837 -137.837)",
  fill: "#de3645"
}), React.createElement("path", {
  d: "M344.715,138.456l-75.357,70.45a1.9,1.9,0,0,1-.326-2.142c14.137-29.288,55.833-57.675,73.266-68.618A1.869,1.869,0,0,1,344.715,138.456Z",
  transform: "translate(-268.837 -137.837)",
  fill: "#c0292c"
})), React.createElement("g", {
  transform: "translate(341.953 94.997)"
}, React.createElement("g", {
  transform: "translate(0)"
}, React.createElement("path", {
  d: "M385.084,129.423a18.194,18.194,0,1,1,.865-25.715A18.195,18.195,0,0,1,385.084,129.423Z",
  transform: "translate(-354.466 -97.939)",
  fill: "#003557"
}), React.createElement("path", {
  d: "M382.885,127.042c-.046.044-.093.088-.141.129a14.4,14.4,0,0,1-20.065-.675c-.044-.043-.089-.091-.132-.138a14.4,14.4,0,1,1,20.338.684Z",
  transform: "translate(-354.865 -98.337)",
  fill: "#33cacd"
}), React.createElement("path", {
  d: "M385.76,123.983a14.39,14.39,0,0,0-22.138-17.963q-.436.406-.825.837A14.394,14.394,0,0,1,384.031,125.6a14.163,14.163,0,0,1-1.659,2.217c.26-.2.514-.421.761-.646.048-.041.095-.085.141-.129A14.35,14.35,0,0,0,385.76,123.983Z",
  transform: "translate(-355.255 -98.337)",
  opacity: 0.1
})), React.createElement("path", {
  d: "M383.39,114.565s-.307,8.212-6.392,11.5c-6.661,3.6-11.807-.1-14.948-6.212,0,0-.028,6.691,7.57,9.778C377.548,132.85,385.91,124.779,383.39,114.565Z",
  transform: "translate(-355.184 -99.513)",
  fill: "#00f0ef"
})), React.createElement("g", {
  transform: "translate(373.086 66.868)"
}, React.createElement("path", {
  d: "M418.47,103.09a125.646,125.646,0,0,1-29.615-31.679,109.668,109.668,0,0,1,30.126-4.543,5.927,5.927,0,0,1,5.136,2.679,6.217,6.217,0,0,1,.913,3.791A109.644,109.644,0,0,1,418.47,103.09Z",
  transform: "translate(-388.855 -66.868)",
  fill: "#de3645"
}), React.createElement("path", {
  d: "M424.446,81.315c.191-1.2.444-2.009.8-3.865.554-2.893.1-4.151-1.884-4.261-3.6-.2-8.436,14.289-4.771,20.065C421.441,97.747,423.62,86.525,424.446,81.315Z",
  transform: "translate(-391.546 -67.466)",
  fill: "#f24c65"
}), React.createElement("path", {
  d: "M418.47,103.09a125.646,125.646,0,0,1-29.615-31.679,109.668,109.668,0,0,1,30.126-4.543,5.927,5.927,0,0,1,5.136,2.679c-1.262-.119-10.352-.777-15.741,4.261C402.573,79.234,404.5,91.448,418.47,103.09Z",
  transform: "translate(-388.855 -66.868)",
  opacity: 0.2
})));

var SvgBooster = function SvgBooster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 187,
    height: 175.335,
    viewBox: "0 0 187 175.335",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBooster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/booster.ebc11297.svg";
export { ForwardRef as ReactComponent };